module.exports = __webpack_public_path__ + "img/credits.91093eed.png";